import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";

export function ErrorState({ message = "Something went wrong.", onRetry, testId = "error-state" }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-md border border-danger/30 bg-danger-bg py-16 text-center"
      data-testid={testId}
    >
      <AlertTriangle size={28} strokeWidth={1.5} className="text-danger" />
      <p className="max-w-md text-sm font-medium text-danger">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry} data-testid="error-state-retry-button">
          Try again
        </Button>
      )}
    </div>
  );
}
